module.exports = __webpack_public_path__ + "img/postback-step-2.en.40a37f6d.jpg";